import { defineMessages } from 'react-intl';

export default defineMessages({
  reports: {
    id: 'Unknown.ReportsScreen.reports',
    defaultMessage: 'Reports'
  },
  buyers: {
    id: 'Unknown.ReportsScreen.buyers',
    defaultMessage: 'Buyers'
  },
  sellers: {
    id: 'Unknown.ReportsScreen.sellers',
    defaultMessage: 'Sellers'
  },
  loadingReport: {
    id: 'Unknown.ReportsScreen.loadingReport',
    defaultMessage: 'Loading report...'
  },
  realtorsActivity: {
    id: 'Unknown.ReportsScreen.realtorsActivity',
    defaultMessage: 'Realtors Activity'
  }
});
